import React from 'react';

const AboutUs = () => {
  return (
    <>
      {/* Page Title Banner */}
      <div className="page-title aos-init aos-animate" data-aos="fade">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 mx-auto">
              <h1 className="">About Mewar University</h1>
              <p>Mewar University has embraced a distinctive two-way teaching-learning methodology since its inception, aimed at equipping individuals with the skills necessary for professional success.</p>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <section id="about" className="about section">
      <div className="container section-title" data-aos="fade-up">
        <h2>University Focus<br /></h2>
        <p>
          <span>Key Highlights of</span> <span className="description-title">Mewar University</span>
        </p>
      </div>

      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <img src="/assets/img/mewar-banner.jpg" className="img-fluid mb-4 aboutkey-img" alt="" />
          </div>
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="250">
            <div className="content ps-0 ps-lg-5">
              <p className="fst-italic">
                Mewar University, established in 2009 by the Government of Rajasthan, is a UGC-recognized and NAAC-accredited autonomous university. 
                It is the only private, self-financed university in Rajasthan approved under UGC 12B, and is a member of AIU with approvals from AICTE, PCI, BCI, IAP, NCC, NSS, and NCTE.
              </p>
              <ul>
                <li>
                  <i className="bi bi-check-circle-fill"></i> 
                  <span>Established in 2009, Mewar University, Rajasthan, is a UGC-approved, student-centric institution attracting learners from across the country.</span>
                </li>
                <li>
                  <i className="bi bi-check-circle-fill"></i> 
                  <span>Founded in 2009 by the Government of Rajasthan through Act No. 4 of 2009.</span>
                </li>
                <li>
                  <i className="bi bi-check-circle-fill"></i> 
                  <span>To empower people with the skills that contribute to professional success, Mewar University has implemented a unique two way teaching learning practice since its inception</span>
                </li>
                <li>
                  <i className="bi bi-check-circle-fill"></i> 
                  <span>University provides the opportunity to discuss personal issues causing distress and gain clarity with the guidance of a trained counselor.</span>
                </li>
                <li>
                  <i className="bi bi-check-circle-fill"></i> 
                  <span>Training begins with formal education and extends to mentoring candidates with industry-relevant skills.</span>
                </li>
                <li>
                  <i className="bi bi-check-circle-fill"></i> 
                  <span>Our University and Training Partners work tirelessly to ensure students are placed in their desired careers.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default AboutUs;
